// extracted by mini-css-extract-plugin
export var dateLabel = "_39-0";
export var dateLabelError = "_39-1";
export var fullWidth = "_39-2";
export var smaller = "_39-3";